'use strict';

/**
 * Collection of objects for the review process
 *
 * @category   Collection
 * @module     import
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var ColidoCollection = require('base/Colido.Collection');
var ReviewObjectModel = require('../models/review-object');

var ReviewObjectsCollection = ColidoCollection.extend({
    model: ReviewObjectModel,
});

module.exports = ReviewObjectsCollection;